import React, { Component } from "react";
import CapabilityContextProvider from "./context/CapabilityContext";
import RouteFilterContextProvider from "./context/RouteFilterContext";
import RouteStatusContextProvider from "./context/RouteStatusContext";
import AssociateContextProvider from "../associate/context/AssociateContext";
import RouteView from "./RouteView";

class RouteStatus extends Component {
  render() {
    return (
      <CapabilityContextProvider>
        <RouteFilterContextProvider context={this.props.match.params.context}>
          <RouteStatusContextProvider>
            <AssociateContextProvider>
              <RouteView history={this.props.history} />
            </AssociateContextProvider>
          </RouteStatusContextProvider>
        </RouteFilterContextProvider>
      </CapabilityContextProvider>
    );
  }
}

export default RouteStatus;



// WEBPACK FOOTER //
// ./src/components/RouteStatus/RouteStatus.js